import React from "react";
import _ from "lodash";
import EditableJsonEditor from "./EditableJsonEditor";
import ClickToCopyWrapper from "./ClickToCopyWrapper";
import { stringifyJson } from "helpers/JsonCheck";

class TextAreaEditorControl extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      data: _.cloneDeep(props.data),

      editValidated: true,
    };

    this.handleDataChanged = this.handleDataChanged.bind(this);
  }

  handleDataChanged({ parsed }) {
    if (_.isNil(parsed)) {
      this.setState({ editValidated: false });
      return;
    }

    this.setState({ data: parsed, editValidated: true });
  }

  // Public function
  getData() {
    if (!this.state.editValidated) {
      return null;
    }
    return this.state.data;
  }

  render() {
    const { handleSyncErrMsg } = this.props;
    const { data } = this.state;

    const parsedCopyData = stringifyJson(data);

    return (
      <>
        <div className="flex items-center justify-end">
          <div>
            <ClickToCopyWrapper
              place="left"
              copyText={parsedCopyData}
              tooltipMessage="Click to copy"
            ></ClickToCopyWrapper>
          </div>
        </div>
        <div style={{ height: "30rem" }}>
          <EditableJsonEditor
            originalConfig={data}
            onChange={this.handleDataChanged}
            handleCheckFormat={handleSyncErrMsg}
          />
        </div>
      </>
    );
  }
}

export default TextAreaEditorControl;
